import { Box, Tooltip } from '@chakra-ui/react'
import React from 'react'

export const withTooltipWrapper = (children) => (
  <Tooltip
    label="Loom currently supports recording only in Google Chrome browsers"
    aria-label="button-tooltip"
    fontSize="0.8em"
    fontWeight='400' 
    textAlign='center'
    bg="#4A5568" 
    rounded='0.25em'
  >
    <Box p='0.5em'>
      {children}
    </Box>
  </Tooltip>
)
